import { useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { PROMPT_QUERY } from './utils/promptUtils';

function usePromptQuery({ promptSlug }) {
  const {
    data, loading, errors
  } = useQuery(PROMPT_QUERY, {
    variables: {
      input: { slug: promptSlug }
    },
    noThrow: true,
    useCache: true
  });

  useError(errors);
  return { errors, data, loading };
}

export { usePromptQuery };
